<template>
  <div style="position: relative; " :style="{width: windowInnerWidth, height: windowInnerHeight}">
    <div class="full-width" v-show="shopChartVisible === false&&shopOrderVisible === false" v-loading="loading">
          <div >
              <ul class="title-box" :style="{'background-image': `url(${publicPath}static/images/Topbg1.png)`,'background-size': 'cover'}">
              <li class="btn-part" style="text-align: left">
                <div style="padding: 5px;width: 50px; height: 50px;" >
                  <img :src="`${publicPath}static/images/ShopopeeLogo.png`" style="width: 100%; height: 100%;user-select:none;"
                       onerror="this.error = null">
                </div>
              </li>
                <li class="btn-part" style="text-align: left;">
                  <div class="icon-part" @click="langSelectVisible = true">
                  <div class="icon-text" >
                      <font-awesome-icon icon="fa-solid fa-language" />
                    </div>
                    <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>
                  </div>
                </li>


                <li class="text-part">
                <div style="padding: 0px 5px;"  >
                  <div style=" height: 40px;max-width: 480px; border: 1px solid black;margin: auto;text-align: left;display: flex;padding: 0px 5px; padding-left: 20px;border-radius: 20px;background-color: #FFFFFF;">
                    <div style="width: 100%;">
                      <input
                        v-model="keyword"
                        class="search-input"
                        :placeholder="`${i18n.tkey('lang_search_text')}...`"
                        v-loading="loadingFlag"
                        @change="changeKeyword"
                    />
                    </div>
                    <el-text style="width:80px;text-align: center;padding: 5px 10px;background-color: #1a9aef;border-radius: 16px;color: #ffffff;" @click="changeKeyword">{{i18n.tkey("lang_search_text")}}</el-text>
                  </div>

                </div>
              </li>
              <li class="btn-part" style="text-align: right;display: grid;grid-template-columns: 1fr 1fr;">

                <div style="width: 50px; height: 50px;color: #e5e5e5;display: none;"   >
                  <div v-if="hallObjInfo!=null&&hallObjInfo.addinfo23 !== '1'" @click="goShopChart" >
                  <el-text style="text-align: center;padding: 5px 10px;background-color: #EF1A56FF;border-radius: 16px;color: #ffffff;float: right;margin-top: -4px;font-size: 10px;" v-if="chartmaterialList!= null && chartmaterialList.length>0" >{{useShopchartinfoRef.materialList.length}}</el-text>

                  <el-text style="text-align: center;padding: 8px 10px;float: right;margin-top: -4px;" v-if="chartmaterialList== null ||chartmaterialList.length<1" ></el-text>
                    <font-awesome-icon icon="fa-solid fa-cart-shopping"  />
                  </div>
                </div>
                <div style="width: 50px; height: 50px;" @click="goLogind" v-show="userInfoRef.memberStatus === 0" >
                  <img :src="`${publicPath}static/images/setting.png`" style="width: 100%; height: 100%;user-select:none;"
                       onerror="this.error = null">
                </div>
                <div style="width: 50px; height: 50px;" @click="goAccountViewd" v-show="userInfoRef.memberStatus === -1" >
                  <img :src="`${publicPath}static/images/setting.png`" style="width: 100%; height: 100%;user-select:none;"
                       onerror="this.error = null">
                </div>
              </li>


            </ul>

              <el-row :style="{'background-image': `url(${publicPath}static/images/Topbg2.png)`,'background-size': 'cover'}">

                <el-col :span="8" style="text-align: center;padding: 10px;">
                  <div class="moving-box2"  @click="goHall">

                    <div class="face front"  :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
                    <img :src="`${publicPath}static/images/3dExpo.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                         onerror="this.error = null">
                    </div>
                    <div class="face back" :style="{'background-image': `url(${publicPath}static/images/icon.png)`,'background-size': 'cover'}">
                      <img :src="`${publicPath}static/images/3dExpo.png`" style="width: 64px; height: 64px;user-select:none;margin: auto;"
                           onerror="this.error = null">
                    </div>
                    <div class="face2 left">
                    </div>
                    <div class="face2 right">
                    </div>
                  </div>
                </el-col>
                <el-col :span="16" style="text-align: left;padding: 10px;color: #FFFFFF">
                  <span v-if="hallObjInfo!=null" @click="goHall"  style="padding-left: 10px;font-size: 1em;text-shadow: 2px 2px 2px #000000;">{{myUtil.isEmpty(hallObjInfo.recordname)?"":hallObjInfo.recordname}}</span>
                  <div style="width: 100%;">
                  <el-row
                      class="scrollable"
                  >
                    <span
                        v-for="(value, index) in companylogoList"
                        :key="value.id"
                    style="padding-left: 5px;">
<!--                    <img v-if="myUtil.isNotEmpty(value.threeShopModel.logo) " class="companyIcon" @click="goEshopopee(value.threeShopModel)"  :src="value.threeShopModel.logo"
                              onerror="this.error = null">-->
                    <div  style="border-radius:25px;background-color:#1a9aef;color: #FFFFFF;border: none;font-size: 8px;display: flex; justify-content: center; align-items: center;" @click="goEshopopee(value.threeShopModel)" type="button" class="companyIcon" >
                     <span style="text-align: center;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;">{{value.threeShopModel.companyName}}</span>
                    </div>
                    </span>
                  </el-row>
                  </div>
                </el-col>
              </el-row>

            <div style="padding: 8px 0px;">
              <el-button-group>
                <el-button
                    :type="queryType === 'buy' ? 'primary' : ''"
                    @click="changeQueryType('buy')"
                >
                  <span tkey="店家推薦">{{i18n.tkey("lang_recommended_bamboo_shoots")}}</span>
                </el-button>

                <el-button
                    :type="queryType === 'buy' ? '' : 'primary'"
                    @click="changeQueryType('buyCompany')"
                >
                  <span tkey="公司介紹">{{i18n.tkey("lang_company_profile")}}</span>
                </el-button>
              </el-button-group>
            </div>
              <div class="type-toggle-box">
                <div v-if="queryType === 'buy'">
                  <ProductTypeTreeSelect
                      v-model="selectedType"
                      v-loading="loadingFlag"
                      @changeSelect="changeProductType"
                  />
                  <span>&nbsp;</span>
                </div>

                <ListDisplayToggle
                    :type="viewType"
                    @clickBtn="changeViewType"
                />
              </div>
          </div>

          <div style="height: calc(100% - 265px);overflow-y: scroll;overflow-x: hidden;"  >
                <div  v-infinite-scroll="scrollLoadFunc" >
                  <el-row :gutter="12" v-if="queryType === 'buy'">
                    <el-col
                        :span="cols"
                        v-for="(value, index) in materialList"
                        :key="value.id"
                        class="record-box"
                    >

                      <SearchMaterialResult
                          :obj="value"
                          :title="value.companyname"
                          :titleDes="``"
                          :imgUrl="myUtil.generateProductImg(value)"
                          :name="value.productname"
                          :description="value.description"
                          :cost="(util.isNotEmpty(value.raddinfo2)?value.raddinfo2:value.cost)"
                          :refercost="value.refercost"
                          :btn-label="i18n.tkey('lang_buy')"
                          :tag="viewType"
                          :type="'buy'"
                          @clickshowMaterial="showMaterial"
                          @click-go-shop="addGoShopChart"
                      />
                    </el-col>
                  </el-row>

                  <el-row :gutter="12" v-if="queryType === 'buyCompany'" >
                    <el-col
                        :span="cols"
                        v-for="(value, index) in companyList"
                        :key="value.id"
                        class="record-box"
                    >
                      <shopHallSearchResultComponent
                          :obj="value"
                          @click-go-shop="goShop" />
                    </el-col>
                  </el-row>


                  <div style="height: 20px;"></div>

                  <el-empty
                      :description="i18n.tkey('lang_temporary_no_data')"
                      v-show="materialList.length == 0 && companyList.length == 0"
                  />
                </div>
          </div>






    </div>

    <div class="shopopee-chat-view" :class="shopopeeChatStatus === 'hide' ? 'shopopee-chat-view-retract' : 'shopopee-chat-view-extend'" v-show="shopopeeChatVisible === true">
      <div style="position: relative; width: 100%; height: calc(100% - 50px);margin-top: 50px;">
        <phoneDemo
            ref="shopopeePhone"
            @exec-command-complete="phoneCommandCallback"
            @login-complete="loginCallback"
            @goShopPosition="goShopPosition"
            @goThreeGuide="goThreeGuide"
            @clickAudio="clickAudio"
            @newShop="clickNewShop"
            @returnShopopee="clickReturnShopopee"
            :class="shopopeeChatStatus === 'hide' ? 'hide-phone' : 'show-phone'"
        />

        <div class="close-div" :class="shopopeeChatStatus === 'hide' ? 'close-div-hide' : 'close-div-show'" @click="hideShopopeeChatBox">
          <font-awesome-icon icon="fa-solid fa-xmark"  />
        </div>
      </div>
    </div>

    <div v-show="shopChartVisible === true" style="height: 100%;">

      <HomeHeader
          :returnLabel="i18n.tkey('lang_shopcart')"
          :useChatBtn="false"
          @clickBackBtn="returnFunc"
      />
      <shopChartView
          :materialList="chartmaterialList != null ? chartmaterialList : []"
          :newTime="newTime"
          :userInfoRef="userInfoRef"
         @clickGoOrder="goOrder"

      />
    </div>
    <div v-show="shopOrderVisible === true" style="height: 100%;">

      <HomeHeader
          :returnLabel="i18n.tkey('lang_my_order')"
          :useChatBtn="false"
          @clickBackBtn="returnFunc"
      />
      <orderDetail  style="padding: 0 16px" v-if="null != detailObj" :obj="detailObj"
         @changeOrder="changeOrderInfo"
      />
    </div>

    <!--    询问框    -->
    <ConfirmComponent
        v-show="confirmVisible === true"
        :confirmText="confirmText"
        @clickSure="sureConfirm"
        @clickCancel="closeConfirm"
    />


  </div>
  <div v-show="shopopeeAdVisible === true" class="overlay2" style="height: 100%;">
    <div class="imgLook">
      <div style="text-align: right;width:100%;padding-right:16px;">
        <button id="prevOff" @click="shopopeeAdVisible = false" style="background-color:red;border-radius:20px;width:40px;height:40px;border: 1px;" class="nav-button">X</button></div>
      <div class="gallery">
      <img :src="imgStr" style="width: 100%;" onerror="this.error = null">

        <el-button v-if="recommendationVisible" type="primary" @click="gotoMoreHall()" tkey="更多展會">{{i18n.tkey("lang_load_more")}}</el-button>
      </div>
    </div>

  </div>

  <languageSelect v-if="langSelectVisible == true" @save-complete="langSelectVisible = false" />
  <el-dialog
      v-model="materialViewVisible"
      :title="i18n.tkey('lang_details')"
      :width="myUtil.isMobile() ? '90%' : '600px'"
      align-center
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialogCallback"
  >
    <div class="my-dialog">
      <ProductInfo
          :obj="currMaterial"
          @clickaddGoShopChart="addGoShopChart"
      />
    </div>
  </el-dialog>

</template>

<script setup>
import {onMounted, ref, toRef, computed, getCurrentInstance, inject, provide, onBeforeMount, watch} from 'vue'
import { useUserinfo } from '@/stores/userinfo'
import { useshopchartinfo } from '@/stores/shopchartinfo'

import myUtil from "@/util/util";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faXmark,
  faMobileScreenButton,
  faCartShopping,
  faBuilding,
  faBoxesStacked,
  faTruck,
  faFileLines,
  faUsers,
  faHandshakeSimple,
  faGlobe,
  faUserTie,
  faFile,
  faPhotoFilm,
  faShareNodes, faComments, faNetworkWired, faBoxesPacking
} from '@fortawesome/free-solid-svg-icons'
import SearchMaterialResult from "@/components/shopopee/dataDisplay/searchMaterialResult.vue";
import materialApi from "@/request/materialApi";
import phoneDemo from '@/views/phoneDemo.vue'
import companyApi from "@/request/companyApi";
import ProductTypeTreeSelect from "@/components/shopopee/whatsShopsBCata/productTypeTreeSelect.vue";
import ListDisplayToggle from "@/components/shopopee/common/listDisplayToggle.vue";
import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
import ShopChartView from "@/components/shopChartView.vue";
import boApi from "@/request/boApi";
import OrderDetail from "@/components/shopchart/orderDetail.vue";
import ConfirmComponent from "@/plugins/projectA/ui/confirmComponent.vue";
import record15Api from "@/request/record15Api";
import ShopHallSearchResultComponent from "@/components/shopchart/shopHallSearchResultComponent.vue";
import record12Api from "@/request/record12Api";
import util from "@/util/util";
import record16Api from "@/request/record16Api";
import ProductInfo from "@/components/shopopee/material/productInfo.vue";

library.add(faXmark,faMobileScreenButton,faCartShopping)
import { faLanguage,faCreditCard } from '@fortawesome/free-solid-svg-icons'
import LanguageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";

const props = defineProps(["hid"])

let { proxy } = getCurrentInstance();
const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())
const useShopchartinfoRef = toRef(useshopchartinfo())

library.add(faLanguage,faCreditCard)


// const companyInfoRef = toRef(useCompanyinfo())

const publicPath = process.env.BASE_URL

const cols = ref(12)
const loading = ref(false)


const materialList = ref([])
const chartmaterialList = ref([])
const companylogoList = ref([])
const companyList = ref([])
let pageNum = 1
let pageSize = 20
const pageObj = ref({})
const keyword = ref("")
const loadingFlag = ref(false)
const selectedType = ref(null)
const viewType = ref("block")
const detailObj = ref(null)
let companyCodelist = ""
//是否显示聊天窗口
let shopopeeChatVisible = ref(false)
let shopChartVisible  = ref(false)
let shopOrderVisible  = ref(false)
//顯示彈窗
let shopopeeAdVisible = ref(false)
//顯示彈窗
let materialViewVisible = ref(false)

let shopopeeChatStatus = ref("hide")
const windowInnerWidth = ref((window.innerWidth) + "px")
const windowInnerHeight = ref((window.innerHeight) + "px")

const numDow1 = ref(0)
const numDow2 = ref(0)
const newTime = ref(0)
//当前展馆信息
const hallObjInfo = ref(null)

const queryType = ref("buy")

const imgStr = ref(null)

const currMaterial = ref(null)

//提示文字
let confirmText = ref("")
//是否提示可见
let confirmVisible = ref(false)
//確定按鈕綁定的方法
let confirmFunc
//取消按鈕綁定的方法
let cancelFunc
//是否提示推薦按鈕
let recommendationVisible = ref(false)
//是否顯示語言選擇框
const langSelectVisible = ref(false)

function scrollLoadFunc(){
  if (null != pageObj.value.hasNextPage && pageObj.value.hasNextPage === true){
  changePage(pageNum + 1)
  }
}
function closeDialogCallback(){
  materialViewVisible.value = false
  currMaterial.value = null
}
// function goCallbackMain(){
//   changeKeyword()
//
// }

// function selectCountryCallback(obj){
//   // getShopList()
//   // userInfoRef.value.selectCountry = code
//   userInfoRef.value.selectCountry = obj.countrycode
//   userInfoRef.value.selectCountryName = obj.zh
//   userInfoRef.value.selectCountryName2 = obj.en
//
//   selectCountryVisible.value = false
//   // islandSelectVisible.value = true
//   // startViewVisible.value = false
// }
function countTo(selector, target) {
  let start = 0;
  const count = () => {
    start += Math.floor(target/24);
    selector.value = start;

    if (start < target) {
      setTimeout(count, 50); // 每100毫秒更新一次计数
    }
  };
  count(); // 启动计数
}


function openConfirm(text, func, func2){
  confirmVisible.value = true
  confirmFunc = func
  cancelFunc = func2
  setTimeout(() => {
    confirmText.value = text
  }, 1250)
}


function sureConfirm() {
  if (typeof confirmFunc === "function"){
    confirmFunc()
  }

  confirmVisible.value = false
  confirmText.value = ""
  confirmFunc = null
  cancelFunc = null

}

function closeConfirm() {
  if (typeof cancelFunc === "function"){
    cancelFunc()
  }

  confirmVisible.value = false
  confirmText.value = ""
  confirmFunc = null
  cancelFunc = null

}

function phoneCommandCallback(functionName, status, data){
  // if (functionName === "openPersonChat" || functionName === "goCardView"){
  shopopeeChatVisible.value = true
  // bottomInteractionUiVisible.value = false
  // upperRightUiVisible.value = false
  // nippleViewVisible.value = false
  // controlFlag = false
  setTimeout(() => {
    shopopeeChatStatus.value = "show"
  }, 25)
  // }
}
function loginCallback(){
  console.log(userInfoRef.value.name)
}
function clickReturnShopopee() {
  hideShopopeeChatBox()

  setTimeout(() => {
    confirmReturnShopopee()
  }, 250)

}

function clickAudio() {

}
function clickNewShop() {
  hideShopopeeChatBox()
}

function confirmReturnShopopee() {
  openConfirm(i18n.tkey("lang_return_shopopee_confirm"), () => {
    window.location.href = `${proxy.$ShopopeeUrl}my_memberwork`
  })
}

function goThreeGuide() {
  hideShopopeeChatBox()

  // setTimeout(() => {
  //   controlFlag = false
  // }, 250)

}

function hideShopopeeChatBox() {
  if (shopopeeChatStatus.value === "hide"){
    return
  }
  shopopeeChatStatus.value = "hide"

  // setTimeout(() => {
  shopopeeChatVisible.value = false
  // bottomInteractionUiVisible.value = true
  // upperRightUiVisible.value = true
  // nippleViewVisible.value = true
  // controlFlag = true
  // }, 1450)
}
function goShopPosition(wa, siojournal, islandid) {
  // if (null != islandid && null != currIsland && islandid != currIsland.id){
    proxy.$router.push({path: `/${islandid}/index/${wa}/${siojournal}`})
  //   reload()
  // }else{
  //   regionMap.selectShopIndex = siojournal
  //   regionMap.currPage = Number(wa) - 1
  //   goNextRegion(false)
  // }

}
function goShopChart(){
  shopChartVisible.value = true
  newTime.value = new Date().getTime();
}


//記錄訪問量
async function saveShopVisits() {

  const request = record12Api.insertHallViewRecord
  const params = request.getParams()

  params.companycode = null
  params.login = userInfoRef.value.login
  params.addinfo1 = userInfoRef.value.hid
  params.addinfo2 = userInfoRef.value.id
  params.addinfo3 = userInfoRef.value.country

  request.send(params, () => {})

}
function goHall(){
  console.log(props.hid)
  userInfoRef.value.hid = null
  //proxy.$router.push({name: "hall"})
  proxy.$router.push({
    path: `/hall/${props.hid}`
  })
}

function goLogind() {
  proxy.$refs.shopopeePhone.goLoginView()

}
function returnFunc(){
  shopChartVisible.value = false
  shopOrderVisible .value = false
}

function changeOrderInfo(orderId){
  getOrderInof(orderId)
}

function goOrder(order){
  shopChartVisible.value = false
  shopOrderVisible .value = true
  detailObj.value = order
}


function goAccountViewd() {
    proxy.$refs.shopopeePhone.goDisplayIndexView()
}


function goShopMaterialList(obj) {
  var whereStr=""
  if(hallObjInfo.value.addinfo23 !=='1'){
    whereStr =`hall=${hallObjInfo.value.id}&`
  }

  if (myUtil.isNotEmpty(userInfoRef.value.login)){//
    whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
  }


  const url = `${proxy.$SSL}://${obj.procedurename}/Web/W006/single_product.asp?${whereStr}productID=${obj.productid}&ProductCompanyCode=${obj.acccode}&CompanyCode=${obj.acccode}&formUrl=exhibition`

  openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyname} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {
    // location.href = url
    myUtil.goURLNewWindow(url, "web")
  })

}

function goShop(obj){
  var whereStr=""
  if(hallObjInfo.value.addinfo23 !=='1'){
    whereStr =`hall=${hallObjInfo.value.id}&`
  }

  if (myUtil.isNotEmpty(userInfoRef.value.login)){//
    whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
  }
  const url = `${proxy.$SSL}://${obj.company.currentcapital}/Web/W006/shop_list.asp?${whereStr}Companycode=${obj.company.acccompanycode}&formUrl=exhibition`

  console.log(url)
  openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.company.companyname} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {
    // const url = myUtil.generateEshopopeeLoginAndJumpUrl(
    //     "/three",
    //     myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
    //     myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
    //     [obj.company.acccompanycode]
    // )
    myUtil.goURLNewWindow(url, "web")
    // proxy.$router.push({path: `/pe/${obj.companyHallId}`})
  })
}

function goEshopopee(obj){
  var whereStr=""
  if(hallObjInfo.value.addinfo23 !=='1'){
    whereStr =`hall=${hallObjInfo.value.id}&`
  }

  if (myUtil.isNotEmpty(userInfoRef.value.login)){//
    whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
  }
  const url = `${proxy.$SSL}://${obj.addinfo7}/Web/W006/shop_list.asp?${whereStr}Companycode=${obj.accCompanyCode}&formUrl=exhibition`

  openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {

    // const url = myUtil.generateEshopopeeLoginAndJumpUrl(
    //     "/three",
    //     myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
    //     myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
    //     [obj.accCompanyCode]
    // )

    myUtil.goURLNewWindow(url, "web")

    // proxy.$router.push({path: `/pe/${obj.companyHallId}`})
  })
}


function showMaterial(obj){

  if(hallObjInfo.value.addinfo23 !='1') {
    materialViewVisible.value = true
    currMaterial.value = obj
  }
    return
  }
function addGoShopChart(obj){
  if(util.formatDate(new Date(), 'yyyy/MM/dd')>hallObjInfo.value.addinfo4){

    openConfirm(`${hallObjInfo.value.recordname}${i18n.tkey("lang_successfully_completed")}!\n ${i18n.tkey("lang_The_event_has_ended")} `, () => {
      // location.href = url
     // myUtil.goURLNewWindow(url, "web")
    })
    return
  }


  updateNumer(obj)
  useShopchartinfoRef.value.companyCode = hallObjInfo.value.companycode

   // if(hallObjInfo.value.addinfo23 ==='1'){
     goShopMaterialList(obj)
   /*}else{
    if (myUtil.isEmpty(userInfoRef.value.login)){//去登錄
      goLogind()
      return
    }


    let materiadata = {
      id:obj.id,
      productname:obj.productname,
      productnamecn:obj.productnamecn,
      qty:1,
      productid:obj.productid,
      curr:obj.curr,
      cost:obj.cost,
      unit:obj.unit,
      procedurename:obj.procedurename,
      acccode:obj.acccode,
    }
    if(util.isNotEmpty(obj.raddinfo2)){
      materiadata.cost = obj.raddinfo2
    }
 if (myUtil.isEmpty(useShopchartinfoRef.value.hid)||props.hid != useShopchartinfoRef.value.hid){
   useShopchartinfoRef.value.hid = hallObjInfo.value.id
   useShopchartinfoRef.value.companyCode = hallObjInfo.value.companyCode
   useShopchartinfoRef.value.materialList = []
   useShopchartinfoRef.value.materialList.push(materiadata)
  }else{
   if (useShopchartinfoRef.value.materialList.length>0){
     var hasChat = false

     for (let i = 0; i < useShopchartinfoRef.value.materialList.length; i++) {

        if(useShopchartinfoRef.value.materialList[i].id ===obj.id){
          hasChat = true
          useShopchartinfoRef.value.materialList[i].qty += 1
        }
     }

     if(!hasChat){
       useShopchartinfoRef.value.materialList.push(materiadata)
     }
   }else{
     useShopchartinfoRef.value.materialList.push(materiadata)
   }
  }
    chartmaterialList.value = useShopchartinfoRef.value.materialList
    newTime.value = new Date().getTime();
   }*/
}

function updateNumer(obj){
  const request = record16Api.updateRecord16Position
  const params = request.getParams()
  var  checknumber = obj.raddinfo3
   if(util.isNotEmpty(checknumber)){
     checknumber = (Number(checknumber)+1)+"";
   }else {
     checknumber = "1"
   }
  obj.raddinfo3 = checknumber
  params.id = obj.rupdatedid
  params.addinfo3 = checknumber


  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
    }else{
      myUtil.alertError(i18n.tkey("lang_save_failed"))
    }
  })
}

function changeViewType(name){
  viewType.value = name

  if (name === "block"){
    if (myUtil.isMobile()){
      cols.value = 12
    }else{
      cols.value = 6
    }
  }else{
    cols.value = 24
  }
}
function changeProductType(){
  changePage(1)
}

function changeQueryType(mqueryType){
  queryType.value = mqueryType
  selectedType.value = null
  changePage(1)
}
function changeKeyword() {
  if (pageNum === 1){
    companyList.value = []
    materialList.value = []
  }

  loadingFlag.value = true
  if(queryType.value === "buy"){
    queryMaterialByPage(queryMaterialCallback)
  } else {
    queryCompanyByPage(queryCompanyCallback)
  }

}
function queryMaterialCallback(detail) {
  if (null != detail && detail.code === 200){
    // materialList.value = detail.detail.list
    materialList.value = materialList.value.concat(detail.detail.list)

    changePageObj(detail.detail)
  }else{
    materialList.value = []

    // myUtil.alertError(detail.msg)
  }
}
function changePage(num){
  pageNum = num
  changeKeyword()
}

function changePageObj(obj){
  if (null == pageObj.value.total || obj.total > pageObj.value.total || obj.pageNum != pageObj.value.pageNum){
    pageObj.value = obj
  }
}
async function queryMaterialByPage(callback) {

  const request = materialApi.queryMaterialRecord16ModelByPage
  const params = request.getParams()
  params.updatedid = props.hid
  params.bcatacode2 = selectedType.value
  params.productname = keyword.value
  params.pageNum = pageNum
  params.pageSize = pageSize


  request.send(params, (res) => {
    loadingFlag.value = false
    if (typeof callback === "function"){
      callback(res)
    }
  })

}

async function queryCompanyByPage(callback) {
  const request = record15Api.getRecord15ListandCompany
  const params = request.getParams()

  params.recordname = keyword.value
  params.updatedid = props.hid

  request.send(params, (res) => {
    loadingFlag.value = false
    if (typeof callback === "function"){
      callback(res)
    }
  })

}


function queryCompanyCallback(detail) {
  if (null != detail && detail.code === 200){
    companyList.value = detail.detail
  }else{
    companyList.value = []
  }

}


onMounted(() => {
  userInfoRef.value.hid = props.hid
  if (null != props.keyword){
    keyword.value = props.keyword
  }
  // if (null == userInfoRef.value.selectCountry){
  //  // selectCountryVisible.value = true
  // }
  if (!myUtil.isMobile()){
    cols.value = 6
  }

  getHallData()
  countTo(numDow1,getHoursTime(243,12))
  countTo(numDow2,getHoursTime(3200,0.5))

  chartmaterialList.value = useShopchartinfoRef.value.materialList
  // getOrderInof("33883")
})

function getOrderInof(orderID){
  const request = boApi.queryBoDetail
  const params = request.getParams()

  params.id = orderID
  request.send(params, (res) => {
    if (res.code == 200){
      detailObj.value = res.detail

      shopOrderVisible .value = true
    }else{
      myUtil.alertError(res.msg)
    }
  })

}
function gotoMoreHall(){
  window.location.href = hallObjInfo.value.addinfo27
}
function getHallData(){

  // if (myUtil.isEmpty(props.hid)){
  //   return
  // }
  if (myUtil.isEmpty(userInfoRef.value.hid)){
    return
  }

  const request = companyApi.getHallListForThree
  const params = request.getParams()

  params.id = userInfoRef.value.hid
  companylogoList.value = []
  request.send(params, (res) => {
    hallObjInfo.value = res.detail
    if(hallObjInfo.value.addinfo4>util.formatDate(new Date(),'yyyy/MM/dd')){
      if(util.isNotEmpty(hallObjInfo.value.addinfo25)){
        shopopeeAdVisible.value = true;
        imgStr.value = hallObjInfo.value.addinfo25
      }
    }else{
      if(util.isNotEmpty(hallObjInfo.value.addinfo26)){
        shopopeeAdVisible.value = true;
        imgStr.value = hallObjInfo.value.addinfo26
      }
      if(util.isNotEmpty(hallObjInfo.value.addinfo27)){
        recommendationVisible.value = true
      }
    }


    useShopchartinfoRef.value.companyCode = hallObjInfo.value.companycode
    companyCodelist = ""
    res.detail.threeHallModelList.forEach((v, i) => {
      companyCodelist+= `${v.threeShopModel.companyCode},`
      if(i<20){
        companylogoList.value.push(v)
      }
      // if(v.threeShopModel.materialModels != null){
      //
      //   v.threeShopModel.materialModels.forEach((v2, i2) => {
      //     materialList.push(v2)
      //   })
      //
      // }
    })
    if(companyCodelist.length>1){
      companyCodelist = companyCodelist.slice(0, -1);
    }
    changeKeyword()
  })
  saveShopVisits()
}

function getHoursTime(seleNum,conditionNum){
  var givenTime = '2024-11-15 00:00:00';

// 将给定时间字符串转换为Date对象
  var givenDate = new Date(givenTime);

// 获取当前时间
  var currentDate = new Date();

// 计算相差的毫秒数
  var diff = currentDate - givenDate;

// 将毫秒数转换为小时数
  var hoursDiff = diff / (1000 * 60 * 60);
  if(hoursDiff>conditionNum){
    seleNum++
  }
  return seleNum
}




</script>

<style scoped>

.moving-box {
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  transform-style: preserve-3d;
  animation: moveUpAndDown 4s infinite alternate;
}

.moving-box2 {
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  transform-style: preserve-3d;
  animation: moveUpAndDown2 4s infinite alternate;
}
.face {
  position: absolute;
  width: 104px;
  height: 80px;
  margin: auto;
  display: flex;
  background: #f0f0f0;
  border: 1px solid #ccc;
}
.face2 {
  position: absolute;
  width: 10px;
  height: 80px;
  margin: auto;
  display: flex;
  background: #f0f0f0;
  border: 1px solid #ccc;
}

.front {
  transform: translateZ(5px);
}

.back {
  transform: rotateY(180deg) translateZ(5px);
}

.right {
  transform: rotateY(90deg) translateZ(98px);
}

.left {
  transform: rotateY(-90deg) translateZ(5px);
}

@keyframes moveUpAndDown2 {
  from {
    transform: translateY(-20px) rotateY(-180deg);
  }
  to {
    transform: translateY(0) rotateY(180deg);
  }
}

@keyframes moveUpAndDown {
  from {
    transform: translateY(0) rotateY(-180deg);
  }
  to {
    transform: translateY(-20px) rotateY(180deg);
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  /* 其他样式，比如高度、背景色等 */
  background-color: transparent;
  color: white;
  text-align: center;
}

ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.title-box {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  font-size: 18px;
  border-bottom: 1px #e9e9e9 solid;
  width: 100%;
  height: 100%;
}

.btn-part {
  width: 25%;
  font-size: 1.5em;
}
.search-result {
  width: 100%;
  height: calc(100% - 110px);
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}
.shopopee-chat-view-extend {
  background: #00000050;
}

.shopopee-chat-view-retract {
  background: #ffffff00;
}

.text-part {
  width: 70%;
}
.shopopee-chat-view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 1.5s ease;
  overflow: hidden;
  z-index: 1001;
}
.btn-span {
  margin-left: 20px;
  margin-right: 20px;
}

.unvisible-savecard-iframe {
  position: absolute;
  left: 0;
  top: 200vh;
  width: 900px;
  height: 900px;
  z-index: 9999;
}

.full-width {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 15px;
}

.icon-text {
  margin-top: 5px;
  font-size: 36px;
  pointer-events: none;
}

.icon-span {
  display: none;
  pointer-events: none;
}
.icon-part{
  width: 50px;
  height: 50px;
  text-align: center;
}

.btn-part .icon-part {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 50%;
  border: #2c3e50;
  margin-right: 10px;
  /*margin-bottom: 10px;*/
}

.btn-part .icon-part .icon-text {
  margin-top: 10px;
  font-size: 20px;
  pointer-events: none;
  padding-top: 8px;
}


@media screen and (min-width: 520px) {
  .shopopee-chat-view .close-div {
    display: inline-block;
    font-size: 24px;
    line-height: 50px;
    color: white;
    position: absolute;
    /*left: 50%;*/
    top: -25px;
    right: 0;
    /*margin-top: -400px;*/
    /*margin-left: 275px;*/
    border-radius: 50%;
    width: 50px;
    height: 50px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    background-color: red;
  //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
  //background: -webkit-linear-gradient(top, #e92323, #551d1d);
    /*transition: all 1.5s ease;*/
    z-index: 100;
  }

  .imgLook {
    font-family: Arial, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    width:80%

  }
}

@media screen and (max-width: 520px) {
  .shopopee-chat-view .close-div {
    display: inline-block;
    font-size: 30px;
    line-height: 40px;
    color: white;
    position: absolute;
    right: 3px;
    top: -20px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    background-color: red;
  //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
  //background: -webkit-linear-gradient(top, #e92323, #551d1d);
    /*transition: all 1.5s ease;*/
    z-index: 100;
  }
  .imgLook {
    font-family: Arial, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    width:100%
  }

}
.coutry-select-render {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}
.shopopee-chat-view .close-div-hide {
  opacity: 0;
  transform: scale(0.5);
  animation: hide-shopopee-chat-close-div 0.5s ease;
}
.type-toggle-box {
  text-align: right;
  box-sizing: border-box;
  padding: 8px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.search-input .el-input__inner {
  border: none;
  box-shadow: none;
}

.search-input .el-input__wrapper {
  border: none;
  box-shadow: none;
}
.search-input{
  border: none;
  box-shadow: none;
  line-height: 38px;
  width: 100%;
  outline:none;
}
.search-input :focus {
  border: none;
  box-shadow: none;
  outline:none;
}
.companyIcon{
  width: 50px;
  height: 50px;
}
.companyIcon:active {
  transform: scale(1.1);
}
.companyIcon:hover {
  transform: scale(1.1);
}
.scrollable {
  overflow-x: auto;
  flex-wrap: nowrap;
  height: 58px;
  padding: 5px;
  //scrollbar-width: none; /* Firefox */
}

/* 针对所有浏览器的隐藏 */
.scrollable::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

/* IE and Edge */
.scrollable {
  -ms-overflow-style: none;  /* IE and Edge */
}
.overlay2 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  height: auto;
  z-index: 1000;
}
</style>